import { render } from "./Sidebar.vue?vue&type=template&id=6ec31f53&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=6ec31f53&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6ec31f53"

export default script